import React from 'react';
import styled from 'styled-components';
import {BodyContainer} from "../Container/Container";
import {P1, P2} from '../Kit/Kit';
import oneBoatImg from '../../assets/img/oneBoatImg.jpg';

const CardContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 30px;
  
   @media(min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    padding-bottom: 150px;
    background: url(${oneBoatImg}) no-repeat bottom right;
  }
`;

const LocationCard = styled.div`
  display: flex;
  flex-direction: column;
`;

const LocationImg = styled.img`
  width: 100%;
  margin-bottom: 10px;
`;

const Address = P2.extend`
  color: #000;
  font-family: Cabin-Bold, sans-serif;
`;

const Phone = P1.withComponent('a');

const PhoneLink = Phone.extend`
  margin-top: 8px;
  color: #004a87;
  text-decoration: none;
`;

const LinkContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const Locations = (props) => {
    const {locations} = props;
    return (
      <BodyContainer>
          <CardContainer>
              {locations.map(i => {
                  const {address, phone_number, location_image: {source_url, alt_text}} = i.node.acf;
                  return (
                    <LocationCard key={i.street}>
                        <LocationImg
                          src={source_url}
                          alt={alt_text}
                        />
                        <Address
                          dangerouslySetInnerHTML={{__html: address}}
                        />
                        <LinkContainer>
                            <PhoneLink title={`Call This H & N Group Location`}
                                       href={`tel: +1${phone_number}`}>{phone_number}</PhoneLink>
                        </LinkContainer>
                    </LocationCard>
                  )
              })}
          </CardContainer>
      </BodyContainer>
    );
};

export default Locations;



// WEBPACK FOOTER //
// ./src/components/Connect/Locations.js